import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class UpdateActiveToServiceTypeCommand extends IRequestCommand<boolean, ErrorDetails, IUpdateActiveToServiceTypeCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carrier/users/{userId}/transportTypes/{serviceTypeId}';

  public setUrlParameters(carrierId: string, serviceTypeId: number) {
    this._commandUrl = this._commandUrl.replace('{userId}', carrierId.toString()).replace('{serviceTypeId}', serviceTypeId.toString());
  }
}

export interface IUpdateActiveToServiceTypeCommandParameters extends ICommandParameters {
  active: boolean;
  userId: number;
}
